var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tooltip',{staticClass:"kst-tooltip",attrs:{"multilined":"","position":_vm.thePosition,"size":_vm.theSize,"type":_vm.theType,"triggers":_vm.theTriggers},scopedSlots:_vm._u([{key:"content",fn:function(){return [(_vm.hasContent)?[_vm._t("content")]:[_vm._v(" "+_vm._s(_vm.theContent)+" ")]]},proxy:true}],null,true)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }